<template>

    <a href="#" v-if="isGuest == false" @click.prevent="isFavProduct ? unFavouriteProduct() : favouriteProduct()" :class="'hover-opacity-7 card-fav-icon'">
        <svg v-if="isFavProduct" width="20" height="19" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" fill="#2da66b"/>
        </svg>
        <svg v-else width="20" height="19" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9974 3.55229C15.4507 1.84563 17.6774 0.765625 19.9974 0.765625C24.1041 0.765625 27.3307 3.99229 27.3307 8.09896C27.3307 13.1348 22.8048 17.2389 15.9476 23.457L15.9307 23.4723L13.9974 25.2323L12.0641 23.4856L12.0114 23.4378C5.17424 17.2246 0.664062 13.1261 0.664062 8.09896C0.664062 3.99229 3.89073 0.765625 7.9974 0.765625C10.3174 0.765625 12.5441 1.84563 13.9974 3.55229ZM13.9974 21.6323L14.1307 21.499C20.4774 15.7523 24.6641 11.9523 24.6641 8.09896C24.6641 5.43229 22.6641 3.43229 19.9974 3.43229C17.9441 3.43229 15.9441 4.75229 15.2507 6.57896H12.7574C12.0507 4.75229 10.0507 3.43229 7.9974 3.43229C5.33073 3.43229 3.33073 5.43229 3.33073 8.09896C3.33073 11.9523 7.5174 15.7523 13.8641 21.499L13.9974 21.6323Z" fill="#2da66b"/>
        </svg>
    </a>
</template>


<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions} from 'vuex';
import UserApis from '@/Components/Controllers/UserApis';

export default {
 
    data() {
        return {
        };
    },
    props:{

        product:{
            type: Object,
            required: false,
            default: null,
        },

    },

    mounted() {
    
    },

    computed: {
        /**
         * If kiosk or user not logged in do not show the fav button
         */
        isGuest() {
            if(this.vg_userId){
                return this.$route.query['kiosk'] ? true : false;
            }
            return true;
        },

        isFavProduct() {
            const self = this;
            let favObj = _.find(this.vg_favProducts, function(o) { return o.id == self.product.id; });
            if(favObj != undefined){
                return true;
            }
            return false;
        },


        ...mapGetters({
            vg_userId: "getLoggedInUserId",
            vg_selectedLocation: "location/selected",
            vg_favProducts: "favouriteproducts/list",
        }),

    },
    methods:{

         /**
         * Fav product
         */
         async favouriteProduct() {
      
            this.va_spinner(true);
            let res = await UserApis.addFavProduct({
                location_id: this.vg_selectedLocation.id,
                location_product_id: this.product.id
            });
            this.va_spinner(false);
            this.va_snackbar({
                message: res.status == 201 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
                type: res.status == 201 ? 'success' : 'error',
            });
        },

        /**
        * Unfav product
        */
        async unFavouriteProduct() {
    
            this.va_spinner(true);
            let res = await UserApis.removeFavProduct({
                location_id: this.vg_selectedLocation.id,
                location_product_id: this.product.id
            });
            this.va_spinner(false);
            this.va_snackbar({
                message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
                type: res.status == 200 ? 'success' : 'error',
            });
        },

        ...mapActions({
            va_spinner: "spinner/setSpinner",
            va_snackbar: "snackbar/setSnackbar",
        })
    }
}
</script>